import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard"
import Cart, {generateCartItemsFrom} from "./Cart"
import { useHistory } from "react-router-dom";
// import generateCartItemsFrom from "./Cart"
/**
 * @typedef {Object} CartItem -  - Data on product added to cart
 * 
 * @property {string} name - The name or title of the product in cart
 * @property {string} qty - The quantity of product added to cart
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

/** Dummy Product view on ProductCard--DOC by Arnet
 * Create a const with a static data of a product
 * Pass as props value to Product card
 * attach and show each product card and make it responsive
 */
// const Product=
// {
// "name":"Tan Leatherette Weekender Duffle",
// "category":"Fashion",
// "cost":150,
// "rating":4,
// "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
// "_id":"PmInA797xJhMIPti"
// }
const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [products,setProduct]=useState([])
  const [isloading, setLoading]=useState(false)
  const [filterproducts, setFilter]=useState([]);
  const [searchnoresult, setsearchResult]=useState(false);
  const[timeout,setTime]=useState(null);
  
  const[items, setItems]=useState()
  // const[qty,setQty]=useState(1)
  const token = localStorage.getItem('token')
  // console.log(`tokrn var:${token}`)

  

  // 
  
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
//  * @property {string} productId - Unique ID for the product
//  */

// const Products = () => {

  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */

  /**MOD-3                 MILESTONE-2-Display Products Grid
   * implement performAPICall function.
   * fetch & return GET/products
   * handle errors and show error messages
   * show loading icon “Loading Products” with API call in progress
   * Display a product grid on page load
   * Organise them in a grid layout. Grid rows - 4 cards(md ) & 2 cards on (xs) 
   */
  const performAPICall = async () => {
    
    setsearchResult(false)
    setLoading(true)
    let message;
    let url= config.endpoint+'/products'
    try{
      
      let res= await axios.get(url)
      
      let productData= res.data;
      // console.log(productData)
      setLoading(false)
      setProduct(productData)
      setFilter(productData)
      return productData
    }catch(err){
      setLoading(false)
      if(err.response){
        if(err.res.status===400){
          message="Failed to fetch"
          return enqueueSnackbar(message,{
            variant:'error',
            autoHideDuration: 3000
          })
      }
      }
      else{
      message='Something went wrong. Check that the backend is running, reachable and returns valid JSON.'
      return enqueueSnackbar(message,{
        variant:'error',
        autoHideDuration: 3000
      })
    }
    }
  }
  

  // useEffect(()=>{
    
  //     performAPICall()
  //   }, [])
  useEffect(()=>{
    const loadHandler = async () => {
      // debugger;
      const dataArr = await performAPICall();
      // console.log("dataArr:" ,dataArr)
      const dataCart = await fetchCart(token);
      // console.log("dataCart:" ,dataCart)
      const cartDetails = await generateCartItemsFrom(dataCart || [], dataArr);
     
      setItems(cartDetails);
    };
    
    loadHandler();
   
    // fetchCart(localStorage.getItem('token'))
  }, [])


  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */

  
 /** MOD-3 MILESTONE-3    Implement search functionality
   * implement the performSearch() fun,
   * it should fetch filtered list and store it & display only new list
   * the search box should call performSearch func
   * API-GET /products/search?value=<search-string>
   *  error handle and show appropriate error messages
   * If the search returned no results-> 
   * show the “No products found” text with a dissatisfied icon
   */

  const performSearch = async (text) => {
    let url=config.endpoint+`/products/search?value=${text}`
    try{
      let res= await axios.get(url);
      let searchData= res.data;
      setsearchResult(false);
      
      setFilter(searchData)
    }catch(error){
      setsearchResult(false);
      
      if(error.response){
        if (error.response.status===404) {
          setsearchResult(true)
           setFilter([])
          
        }if(error.response.status===500){
          enqueueSnackbar(error.response.data.message,{variant:"error"})
          setProduct(products)
        }
       } else{
          let message='Something went wrong. Check that the backend is running, reachable and returns valid JSON.'
        return enqueueSnackbar(message,{
          variant:'error',
          autoHideDuration: 3000
        })
        }
    }

  };


  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */

   /**MODE-3 MILESTONE-4
   * implement debounceSearch(event, debounceTimeout) function 
   * to be called on the onChange() event of the search bar
   * func takes two arg:
   * event → The onChange event object
   * debounceTimeout → Reference to the debounce timer set
   * Call the performSearch() function in debounceSearch()
   * Implement debouncing in the debounceSearch() function
   * set the debounce timeout to 500ms
   */
  const debounceSearch = (event, debounceTimeout) => {
    // setFilter(event)
    if(timeout){
      clearTimeout(timeout); 
    }
    const timerId= setTimeout(()=>{
      performSearch(event)
    },debounceTimeout)

    setTime(timerId)
  };







  // const debounceSearch = (event, debounceTimeout) => {
  // };


  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */
   /**MODULE_4    MILESTONE -3    ---->  get the Products page to fetch the GET /cart data on load
   *complete fetchcart() func
   * Write API logic for GET/cart endpoint
   * understand the requirements
   * @param {string} token --> user token value after he logged in
   * API request  format GET/cart{curl 'http://localhost:8082/api/v1/cart' \
  -H 'Authorization: Bearer <token>'}
   * @returns {Array[{"productId":"BW0jAAeDJmlZCF8i","qty":1}]}
   */
  const fetchCart = async (token) => {
    // debugger;
    if (!token) return null

    try {
      // TODO: CRIO_TASK_MODULE_CART - Pass Bearer token inside "Authorization" header to get data from "GET /cart" API and return the response data
      const url=config.endpoint+'/cart';
      let res= await axios.get(url,{
        headers:{
          'Authorization': `Bearer ${token}` 
        }
      })
      // console.log(`fetchCart${res}`)
      // setCart(res.data)
     
      return res.data
      // generateCartItemsFrom(cart, products)
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  
  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */

  /** MODULE-4 MILESTONE -5 Add Products to Cart
   * utilize with POST/cart endpoint to get the Add products to cart functional and other
   * make required updates to your ProductCard.js, Products.js and Cart.js components.
   * 1->to add a new product to the cart use  <Button>"Add to cart "</Button>
   * 2->if user isn't logged in, instead of API call show a warning message, "Login to add an item to the Cart".
   * 3-> if the "Add to cart" button clicked which is already in the cart show a warning with message,
   * "Item already in cart. Use the cart sidebar to update quantity or remove item."-> 
   * use the isItemInCart to check this
   * 4-> to update the existing product in the cart use "+/-" </BUTTON>
   * 5->setting quantity of the product to 0 should remove the product from the cart.
   * 6-> refreshing the page shouldn't lose track of the products added to cart
   * Implement the addtocart func in product.js to handle both <Button>ADD TO CART</Button> & +/- clicks.
   * -->Pass the addToCart() func with suitable arguments as props to <ItemQuantity> component from Cart.js
   *    to set event handlers for the <BUTTON>+ & - </BUTTON>
   * -->utilize response data on frontend and & not waste API bandwidthby making GET/cart request.
   * 
   * 
   *
   */
  const isItemInCart = (items, productId) => {
  // let result= false;
  // items.forEach((item)=>{
  //   if(item.productId===productId)
  //   return result= true;
  // })
  // return result

  if(items){
    return items.findIndex((item)=>item.productId===productId)!== -1
  }
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
 const updateCartItems=(newCartdata, productData)=>{
       const cartItems= generateCartItemsFrom(newCartdata,productData)
      setItems(cartItems)
  }
  const addToCart = async (
    
    token,
    items,
    products,
    productId,
    qty,
    options = { preventDuplicate: false }
  ) => {
    // debugger;
    // console.log(`productId: ${productId}`)
    // console.log(`token: ${token}`)
    if(!token){
      return enqueueSnackbar('Login to add an item to the Cart',{
        variant:"warning"
      })
    }else if(options.preventDuplicate && isItemInCart(items, productId)){
      return enqueueSnackbar('Item already in cart. Use the cart sidebar to update quantity or remove item.',{
        variant:"warning"
      })
    }
      
      
      try{
        let url=`${config.endpoint}/cart`
        const res= await axios.post(url,
          { productId,   qty  } ,{
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}` 
            }
        })
      //  console.log(res.data)
        updateCartItems(res.data,products)
      }catch(e){
          if(e.res){
            enqueueSnackbar(e.res.data.message, {
              variant:"error"
            })
          }else{
            enqueueSnackbar(
              "Could not fetch products. Check that the backend is running, reachable and returns valid JSON.",
              {
                variant: "error",
              }
            );
          }
      }
    
  };

  /**MOD-4 MILESTONE -1 Display empty cart on Products page
   * <Cart /> component should be rendered.
   * to display empty cart on the right side of the product page.
   * Cart should display 25% width on {md} devices
   * Cart should come below on smaller devices.
   */
  // const token=localStorage.getItem("token")

  return (
    <div>
      <Header >
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
        {/**Mod-3 MILESTONE-3- Implement Search
   * implement search bar only on products page using
   * products.js & header.js
   * set the search-desktop class for search box
   * placeholder attribute with its value as "Search for items/categories"
   * children props value in the Header.js component to render the search view. 
   */}
        
        <TextField 
        className="search-desktop"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search" 
        onChange={(e)=>debounceSearch(e.target.value,500)}
        />

      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        
        onChange={(e)=>debounceSearch(e.target.value,500)}
      />

         
       <Grid container spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
       
       >
         <Grid item 
          xs={12}
          md={token? 9 : 12}
         className="product-grid">
           <Box className="hero">
             <p className="hero-heading">
               India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
               to your door step
             </p>
           </Box>
          
               
               { isloading ? (
                 <Box className="loading"
                 >
                 <CircularProgress />
                 <p>Loading Products...</p>
                 </Box>
               ):

                
                
                (<Grid  container spacing={2} >
             {filterproducts.length ? 
             (
               filterproducts.map((product)=>
                 (
                 <Grid item xs={6}  md={3} key={product._id}>
                  <ProductCard  product={product} 
                  handleAddToCart={async ()=>{await addToCart(token,items,products,product._id,1,{preventDuplicate:true})}}/>
               </Grid>

                 )
               ) ): (<Box className="loading">
                
                <SentimentDissatisfied />
                <p>No Products Found</p>
                 
                </Box>)  } </Grid>)
               }
             

        
         </Grid>
        {/* TODO: CRIO_TASK_MODULE_CART - Display the Cart component */}
               
       { token ?(
       <Grid item 
       xs={12}
       md={3}
       >
           <Cart products={products} items={items} handleQuantity={addToCart} bgcolor="#E9F5E1" />
           </Grid>) : null }
        </Grid>
      <Footer />
    </div>
  );
};

export default Products;
